import { TOKEN_UNIT, UNIT } from '~/environment-variables/unit.const'
import { ITokenType } from '~/types/token-type.type'
import { Column } from '~/ui/Table/types'

export const TOKEN_TYPE_NAME = {
  [ITokenType.ERC20]: 'ERC-20',
  [ITokenType.ERC721]: 'ERC-721',
  [ITokenType.ERC1155]: 'ERC-1155',
  [ITokenType.NATIVE]: 'Native Token',
}

export const MARKETPLACE_URL = 'https://msu.io/marketplace'

export const NFT_TRADES_COLUMN: Array<Column> = [
  {
    name: 'TXH HASH',
    field: 'transactionHash',
  },
  {
    name: 'AGE',
    field: 'age',
    isToggleColumn: true,
  },
  {
    name: 'DATETIME',
    field: 'unixTimeStamp',
    isToggleColumn: true,
  },
  {
    name: 'SELLER',
    field: 'sellerAddressInfo',
  },
  {
    name: '',
    field: 'arrow-right',
  },
  {
    name: 'BUYER',
    field: 'buyerAddressInfo',
  },
  {
    name: 'PRICE',
    field: 'price',
    unit: TOKEN_UNIT,
    isHoverable: true,
  },
  {
    name: 'QUANTITY',
    field: 'quantity',
    isHoverable: true,
  },
  {
    name: 'COLLECTION',
    field: 'tokenInfo',
  },
  {
    name: 'ITEM',
    field: 'item',
  },
]

export const NFT_MINTS_COLUMN: Array<Column> = [
  {
    name: 'TXH HASH',
    field: 'transactionHash',
  },
  {
    name: 'AGE',
    field: 'age',
    isToggleColumn: true,
  },
  {
    name: 'DATETIME',
    field: 'unixTimeStamp',
    isToggleColumn: true,
  },
  {
    name: 'MINTER',
    field: 'minterAddressInfo',
  },
  {
    name: 'QUANTITY',
    field: 'quantity',
    isHoverable: true,
  },
  {
    name: 'COLLECTION',
    field: 'tokenInfo',
  },
  {
    name: 'ITEM',
    field: 'item',
  },
]

export const NATIVE_TOKEN = {
  symbol: UNIT,
  address: '0xf2b51cc1850fed939658317a22d73d3482767591',
  tokenType: ITokenType.NATIVE,
}

export const NESO_TOKEN = {
  symbol: TOKEN_UNIT,
  address: '0x07e49ad54fcd23f6e7b911c2068f0148d1827c08',
  tokenType: ITokenType.ERC20,
}

export const TETHER_USDT_TOKEN = {
  symbol: 'USDt',
  name: 'TetherToken',
  address: '0xa75aae282802add5bfae39bc5fe0d4d27b117d0a',
  tokenType: ITokenType.ERC20,
}

/**
 * 알려진 토큰 주소 → SEO용 심볼 매핑
 * NXPC는 별도 라우트(/tokens/nxpc)를 사용하므로 제외
 */
const TOKEN_SEO_MAP: Record<string, string> = {
  [NESO_TOKEN.address.toLowerCase()]: NESO_TOKEN.symbol,
  [TETHER_USDT_TOKEN.address.toLowerCase()]: TETHER_USDT_TOKEN.symbol,
}

export const getTokenSeoName = (address: string): string | null => {
  return TOKEN_SEO_MAP[address.toLowerCase()] ?? null
}
